
import { Link } from 'react-router-dom';

const HeroExperiencias = () => {
  return (
    <section className="relative h-[70vh] min-h-[600px] w-full overflow-hidden">
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://public.readdy.ai/ai/img_res/a5ed80049fa6e3edbceb490b9dd30588.jpg"
          alt="Experiências na Madeira"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>
      </div>

      <div className="relative z-10 h-full flex items-center justify-center text-center">
        <div className="max-w-4xl px-6">
          <p className="text-nature-green bg-white/90 inline-block px-4 py-2 rounded-full text-xs font-semibold uppercase tracking-wider mb-6">
            Madeira Island Experiences
          </p>
          <h1 className="text-white text-5xl md:text-6xl lg:text-7xl font-light mb-6 leading-tight">
            Experiências <span className="font-serif italic">Inesquecíveis</span>
            <br />na Madeira
          </h1>
          <p className="text-white/90 text-lg md:text-xl leading-relaxed mb-10 max-w-2xl mx-auto">
            Da adrenalina dos passeios de mota às levadas serenas, dos golfinhos no oceano 
            aos sabores autênticos — descubra tudo o que a Ilha da Madeira tem para oferecer.
          </p>
          <Link
            to="/apartamentos"
            className="inline-flex items-center justify-center px-8 py-4 bg-sea-blue text-white rounded-full font-semibold text-base hover:bg-sea-blue/90 hover:shadow-xl transition-all whitespace-nowrap cursor-pointer group"
          >
            Reserve o Seu Alojamento
            <i className="ri-arrow-right-line ml-2 text-xl group-hover:translate-x-1 transition-transform"></i>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default HeroExperiencias;
